import { render, staticRenderFns } from "./font-awesome-icon.vue?vue&type=template&id=2e22f953"
import script from "./font-awesome-icon.vue?vue&type=script&lang=ts"
export * from "./font-awesome-icon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports